<template>
  <div class="container-list">
    <div class="card-container">
      <h4 class="index__login-title app-title with-bar">
        Sincronizar
        <div class="line-big"></div>
      </h4>
      <div class="input-container">
        <input
          type="text"
          class="primary-input"
          id="code-input"
          placeholder="Digite o código do Totem"
          v-model="templateId"
          maxlength="14"
          @focus="onFocus('code-input')"
          @input="templateId = formatInput(templateId)"
        />
        <input
          type="password"
          class="primary-input"
          id="password-input"
          v-model="password"
          placeholder="Senha de acesso"
          @focus="onFocus('password-input')"
        />
      </div>
      <div class="divisor" />
      <button
        class="primary-button"
        :disabled="templateId == ''"
        @click="handleSubmit"
      >
        Continuar
      </button>
    </div>

    <Keyboard
      v-if="showKeyboard"
      v-model="activeInputValue"
      @enter="handleEnter"
      @close="showKeyboard = false"
      :mask="formatInput"
    />
    
    <loading :active.sync="isLoading" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import TotemService from "../services/TotemService";
import Keyboard from "../components/Keyboard.vue";

export default {
  name: "SyncPage", 
  data() {
    return {
      templateId: "",
      password: "",
      totemService: new TotemService(),
      isLoading: false,
      currentInput: "", 
      showKeyboard: false,
    };
  },
  computed: {
    activeInputValue: {
      get() {
        if (this.currentInput === "code-input") {
          return this.templateId;
        }
        if (this.currentInput === "password-input") {
          return this.password;
        }
        return "";
      },
      set(newValue) {
        if (this.currentInput === "code-input") {
          this.templateId = newValue;
        } else if (this.currentInput === "password-input") {
          this.password = newValue;
        }
      },
    },
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true;
      const totemId = { ident: this.templateId, senha: this.password };

      await this.totemService
        .validateTotemId(totemId)
        .then((response) => {
          if (response.success) {
            this.$store.commit("setAuth", true);
            this.$store.commit("setSessionTotem", response.data.ident);
            this.$router.push("/home");
          }
        })
        .catch((error) => {
          if (error.response && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      this.isLoading = false;
    },

    onFocus(inputId) {
      this.currentInput = inputId;
      this.showKeyboard = true;
    },

   formatInput(input) {
  const clean = input.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  return clean.match(/.{1,4}/g)?.join("-") || "";
},
    handleEnter() {
      if (this.templateId !== "" && this.password !== "") {
        this.handleSubmit();
      } else {
        this.showKeyboard = false; 
      }
    },
    setScheduleDefaultValues(){
      this.$store.commit("setScheduleCompany", {});
    this.$store.commit("setScheduleDepartment", {});
    this.$store.commit("setScheduleReason", "");
    this.$store.commit("setSchedulePhoto", "");
    this.$store.commit("setLogoffSessionTotem", "");
    this.$store.commit("setKeyboardStatus", false);
    }
  },
  mounted() {
    this.setScheduleDefaultValues();
  },
  components: {
    Loading,
    Keyboard,
  },
};
</script>

<style>
/* .primary-input {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #eff4fc;
  background-color: #eff4fc;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #888791cc;
} */

.input-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.divisor {
  width: 100%;
  height: 2px;
  background-color: #dfe2e6;
  margin: 20px 0;
}

.card-container {
  width: 65%;
}

/* .submit-button {
  width: 100%;
  padding: 12px;
  border: none;
  background-color: #de3517;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 300;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.submit-button:disabled {
  background-color: #dfe2e6;
  color: #888791;
  cursor: not-allowed;
} */
</style>
